import { render } from "./HeadingBloc.vue?vue&type=template&id=ea7f1fde"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__